
import SummaryPerson from "@/components/summary-panel/SummaryPerson.vue";
import SummaryOrganization from "@/components/summary-panel/SummaryOrganization.vue";
import SummaryCotation from "@/components/summary-panel/SummaryCotation.vue";
import { Options, Vue } from "vue-class-component";
import { OfferAssociatedParty } from "@/types";

@Options({
  components: { SummaryPerson, SummaryOrganization, SummaryCotation },
  props: ["arrParties"],
})
export default class SummaryTiers extends Vue {
  arrParties?: Array<OfferAssociatedParty>;
  tab?: string = "";
  filteredParties?: Array<OfferAssociatedParty>;
  get buildParties() {
    if (this.arrParties) {
      this.filteredParties = this.arrParties.filter((el: any) => el.role_code !== "DIRG");

      const parties: any[] = [...this.filteredParties];

      const getRole = (item: any) => item?.associatedParty?.role_code;
      const getPartySiretSG = (item: any) => item?.businessData?.siretSG;
      const getSGSiret = (item: any) => item?.associatedParty?.third?.facilities?.[0]?.siret;

      const sgParties: any[] = parties.filter((item: any) => getRole(item) === "SG");
      const nonSGParties: any[] = parties.filter((item: any) => getRole(item) !== "SG");

      const used: Set<any> = new Set();
      const result: any[] = [];

      const getKey = (item: any) =>
          item?.resourceUid ||
          item?.uid ||
          item?.associatedParty?.resourceUid;

      const pushItem = (item: any) => {
        if (!item) return;

        const key = getKey(item);
        if (!key || used.has(key)) return;

        used.add(key);
        result.push(item);
      };

      const findAssociatedSG = (partyItem: any) => {
        if (!partyItem) return null;

        const partySiretSG = getPartySiretSG(partyItem);
        if (!partySiretSG) return null;

        return (
            sgParties.find((sg: any) => {
              const sgSiret = getSGSiret(sg);

              return !used.has(getKey(sg)) && !!sgSiret && partySiretSG === sgSiret;
            }) || null
        );
      };

      const locataire: any = nonSGParties.find(
          (item: any) => getRole(item) === "CUSTOMER" || getRole(item) === "LOCATAIRE"
      );

      pushItem(locataire);
      pushItem(findAssociatedSG(locataire));

      const colocataires: any[] = nonSGParties.filter(
          (item: any) => getRole(item) === "COLOCATAIRE"
      );

      colocataires.forEach((colocataire: any) => {
        pushItem(colocataire);
        pushItem(findAssociatedSG(colocataire));
      });

      nonSGParties
          .filter((item: any) => {
            const role = getRole(item);
            return role !== "CUSTOMER" && role !== "LOCATAIRE" && role !== "COLOCATAIRE";
          })
          .forEach((item: any) => pushItem(item));

      sgParties.forEach((sg: any) => pushItem(sg));

      this.filteredParties = result;

      if (this.filteredParties.length > 0) {
        this.tab = this.filteredParties[0]?.associatedParty?.resourceUid;
      }

      return this.filteredParties;
    }

    return [];
  }

  mergePartyBusinessData(item: any): Record<string, unknown> {
    const third = item?.associatedParty?.third;
    return {
      ...(third?.businessData ?? {}),
      ...(third?.person?.businessData ?? {}),
      ...(third?.organization?.businessData ?? {}),
      ...(item?.businessData ?? {}),
    };
  }

  isCustomerParty(item: any): boolean {
    const role = item?.associatedParty?.role_code
      || item?.role_code
      || item?.associatedParty?.role?.resourceUid;
    return role === "CUSTOMER" || role === "LOCATAIRE";
  }
}
